import root from "./_root.js";
var coreJsData = root["__core-js_shared__"];
export default coreJsData;
